import React, { useState, useEffect } from 'react';
import { func, shape, string, bool, any } from 'prop-types';
import { BoxChecked, BoxUnchecked } from '@magalu/stereo-ui-icons';
import { Container, IconContainer, ItemContainer, Button } from './filter-item.styles';
import Text from '../../atoms/Text';

const FilterItem = ({
  item,
  onClick,
  children
}) => {
  const {
    label,
    selected
  } = item;
  const [checked, setChecked] = useState(selected);
  useEffect(() => {
    setChecked(selected);
    return () => {
      setChecked(false);
    };
  }, [selected]);
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    onClick: e => onClick(e, item),
    "aria-label": `Filtrar por ${item.name}`,
    "data-testid": "filter-item"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(IconContainer, {
    role: "checkbox",
    "aria-checked": selected,
    "aria-labelledby": label
  }, checked ? /*#__PURE__*/React.createElement(BoxChecked, {
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement(BoxUnchecked, {
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(ItemContainer, {
    children: children || /*#__PURE__*/React.createElement(Text, {
      fontSize: 1,
      id: label
    }, label)
  }))));
};

process.env.NODE_ENV !== "production" ? FilterItem.propTypes = {
  onClick: func,
  children: any,
  item: shape({
    label: string,
    selected: bool
  })
} : void 0;
FilterItem.defaultProps = {
  item: {
    selected: false
  },
  children: null,
  onClick: () => ({})
};
export default FilterItem;